import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import Box from '../layout/Box';

const SelectInput = (props) => {
  const { label, error, onChange, value, name, className, options } = props;

  return (
    <Box className="mb-2 flex-column">
      <FloatingLabel controlId={name} label={label} className={className}>
        <Form.Select
          onChange={onChange}
          value={value}
          isInvalid={!!error}
          aria-label="Floating label select example"
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.title}
            </option>
          ))}
        </Form.Select>
        <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
      </FloatingLabel>
    </Box>
  );
};

export default SelectInput;
